





















import Vue, { PropType } from 'vue';
    import { TaskNoticesItem } from '@/api'; // ConverStatus
import moment from 'moment';

export default Vue.extend({
    props: {
        visable: { type: Boolean },
        list: { type: Array as PropType<TaskNoticesItem[]> },
    },
    filters: {
         formatTime(val) {
        return moment(val).format('YYYY.MM.DD HH:mm:ss');
    },
    },
});
